import { CircularProgress } from "@material-ui/core";
import React from "react";
import "./IntermediateLoader.scss";

const IntermediateLoader = ({content}) => {
  return (
    <>
      <div className="light-bg">
        <div className="content-box-home">
          <div className="loader-div">
            <CircularProgress size="48px" color="#D4D3D9 " />
            <h2>Please wait!</h2>
            {content}
          </div>
        </div>
      </div>
    </>
  );
};
export default IntermediateLoader;
